import Vue from "vue";
import App from "@/App";
import router from "@/router";
import store from "@/store";
import moment from "moment";
import * as echarts from "echarts";
import "@/plugins/vant.js";
import "pdfh5/css/pdfh5.css";
import "@/assets/styles/normalize.scss";
import "@/assets/styles/font-awesome.min.css";
import "video.js/dist/video-js.min.css";
import "@/assets/styles/common.scss";
import "amfe-flexible";

Vue.config.productionTip = false;
Vue.prototype.$echarts = echarts;
Vue.prototype.$moment = moment;

Vue.directive("hide", {
  update: function (el, { value }) {
    if (value) {
      el.classList.add("m-hide");
    } else {
      el.classList.remove("m-hide");
    }
  },
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
